import { JSX } from "react";

import {
	EvaluationScoresWidget,
	Widget,
	WidgetKind
} from "core/blueprint/dashboard/DashboardTypes";
import { Evaluation } from "trajectory/TrajectoryService";

import { EvaluationHistoryWidgetView } from "./EvaluationHistoryWidgetView";
import EvaluationScoresWidgetView from "./EvaluationScoresWidgetView";

export type WidgetViewProps<T extends Widget> = {
	widget: T;
	evaluation: Evaluation;
	// The day whose state to render; absent means the current state.
	asOf?: Date;
};

export default function WidgetView(
	props: Readonly<WidgetViewProps<Widget>>
): JSX.Element {
	switch (props.widget.type) {
		case WidgetKind.EVALUATION_SCORES:
			return (
				<EvaluationScoresWidgetView
					{...props}
					widget={props.widget as EvaluationScoresWidget}
				/>
			);
		case WidgetKind.EVALUATION_HISTORY:
			return <EvaluationHistoryWidgetView {...props} />;
		default:
			return <></>;
	}
}
